import { IAddress } from '@app/interfaces';

export default class Address implements IAddress {
    public addressLine1: string | null = null;
    public addressLine2: string | null = null;
    public city: string | null = null;
    public state: string | null = null;
    public postalCode: string | null = null;

    public constructor() {

    }

    // Checks to see if a generic object is a instance of class Address.
    public static isAddress(objToCheck: any): objToCheck is Address {
        return (objToCheck as Address).addressLine1 !== undefined
            && (objToCheck as Address).addressLine2 !== undefined
            && (objToCheck as Address).city !== undefined
            && (objToCheck as Address).state !== undefined
            && (objToCheck as Address).postalCode !== undefined;
    }
};